const state = {
  showLoading: false,
  showPWAInstallationToast: false,
};

const getters = {
  showLoading: (state) => state.showLoading,
  showPWAInstallationToast: (state) => state.showPWAInstallationToast,
};

const actions = {
  showLoading({ commit }, payload) {
    commit("showLoading", payload);
  },
};


const mutations = {
  showLoading: (state, data) => (state.showLoading = data),
  showPWAInstallationToast: (state, data) =>
    (state.showPWAInstallationToast = data),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
